<template>
  <div class="circular-progress">
    <svg viewBox="0 0 36 36" class="circular-chart">
      <path
        class="circle-bg"
        d="M18 2.0845
           a 15.9155 15.9155 0 0 1 0 31.831
           a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        class="circle"
        :stroke-dasharray="percentage + ', 100'"
        d="M18 2.0845
           a 15.9155 15.9155 0 0 1 0 31.831
           a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" class="percentage">{{ percentage }}%</text>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      required: true,
      validator: val => val >= 0 && val <= 100
    }
  }
}
</script>

<style scoped>
.circular-progress {
  width: 120px;
  height: 120px;
}
.circular-chart {
  display: block;
  margin: auto;
  max-width: 100%;
  max-height: 250px;
}
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}
.circle {
  fill: none;
  stroke-width: 3.8;
  stroke: #00acc1;
  stroke-linecap: round;
  transition: stroke-dasharray 0.5s ease;
}
.percentage {
  fill: #444;
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
}
</style>
